import React, { useState } from 'react';
import { User } from '@/database/userDatabaseService';
import { ColorIcon, PreviewThicknessIcon } from '@/icons';

interface PenSubToolProps {
  user: User;
  selectedColor: string;
  selectedThickness: number;
  setSelectedColor: (color: string, userId: string) => void;
  setThickness: (thickness: number, userId: string) => void;
  isMarker?: boolean;
  subtoolPosition: string; // Expected position values (e.g., "left", "right")
}

const PenSubTool: React.FC<PenSubToolProps> = ({
  user,
  selectedColor,
  selectedThickness,
  setSelectedColor,
  setThickness,
  isMarker = false,
  subtoolPosition,
}) => {
  const [thickness, setLocalThickness] = useState<number>(selectedThickness);

  const incrementThickness = () => {
    if (thickness < 21) {
      const newThickness = thickness + 1;
      setLocalThickness(newThickness);
      setThickness(newThickness, user.id);
    }
  };

  const decrementThickness = () => {
    if (thickness > 1) {
      const newThickness = thickness - 1;
      setLocalThickness(newThickness);
      setThickness(newThickness, user.id);
    }
  };

  const setOpacity = (color: string, opacity: number): string => {
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  };

  return (
    <div
      className={`sub-tools ${subtoolPosition}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="color-div">
        {user.userSettings?.colors.map((color: string) => (
          <div
            className="color-icon"
            key={`color-${color}`}
            onClick={() => setSelectedColor(color, user.id)}
          >
            <ColorIcon color={color} className={undefined} size={undefined} />
          </div>
        ))}
      </div>

      <div className="thickness-div">
        <h4>Boyut: </h4>
        <div className="number-display">
          <button onClick={decrementThickness}>-</button>
          <span className="thickness-value">{thickness}</span>
          <button onClick={incrementThickness}>+</button>
        </div>
      </div>

      <div className="color-preview">
        <PreviewThicknessIcon
          color={
            !isMarker
              ? selectedColor
              : setOpacity(selectedColor, 0.5)
          }
          thickness={thickness * 3}
        />
      </div>
    </div>
  );
};

export default PenSubTool;
